import fetch from '@/utils/fetch';

// zym.保存菜单信息
export function menuCreate(params){     
     return fetch({
        //  url:'Rule/Rule/saveMenu',
         url:'manage/menu/saveMenu',
         method:"post",
         data:params
     })
}

// zym.显示菜单
export function getMenu(params){     
     return fetch({
        //  url:'Rule/Rule/getMenuTree',
         url:'manage/menu/getPostRuleTree',
         method:"post",
         data:params
     })
}

// zym.删除菜单
export function delDot(params){     
     return fetch({
        //  url:'Rule/Rule/delMenu',
         url:'manage/menu/delMenu',
         method:"post",
         data:params
     })
}


// WEBPACK FOOTER //
// ./src/api/pgMent/modelSet.js